export const MODEL_ROUTE = '/containers';
